import React from "react";
import "../../sass/files/card.scss";
import { MdDeleteOutline } from "react-icons/md";

const OrderCard = (props) => {
  const handleCheckout = async () => {
    try {
      console.log("Checking payload data:", props.price, props.title);

    if (props.price == null || props.price === "" || isNaN(Number(props.price))) {
  props.setSelectedOrder(props.orderId);

  const drawerToggle = document.getElementById("my-drawer-4");
  if (drawerToggle) {
    drawerToggle.checked = true;
  }

  return;
}

const priceWithTax = (Number(props.price) * 1.045).toFixed(2);
const depositAmount = (Number(priceWithTax) / 2).toFixed(2);

      const payload = {
        price: depositAmount,
        title: props.title,
        email: props.emailId,
      };

      const res = await fetch(
        "https://prod-api.3dspot.io/api/v1/orders/create-payment-intent",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.message || "Failed to create payment intent");
      }

      props.setClientSecret(data.clientSecret);
      props.setSelectedOrder(props.orderId);

      const drawerToggle = document.getElementById("my-drawer-4");
      if (drawerToggle) {
        drawerToggle.checked = true;
      }
    } catch (error) {
      console.error("Error creating payment intent:", error);
    }
  };

  return (
    <div className="card bg-neutral min-w-[250px] max-w-[320px] h-[375px]">
      <div className="grid grid-cols-1">
        <div className="p-3">
          <img
            className="mx-auto w-full h-[170px] object-cover"
            src={`https://project3dspot.s3.ap-south-1.amazonaws.com/${props.image}`}
            alt={props.title || "Order preview"}
          />

          <h2 className="card-title py-3">
            {props.title?.length < 20
              ? props.title
              : props.title?.substring(0, 19) + "..."}
          </h2>

          <p className="text-xs flex gap-2 items-center mb-1">
            Created On {props.date?.replace("T", " ").slice(0, -5)}
          </p>

          <p className="text-xs">{props.status?.toUpperCase()}</p>

          <h2 className="card-title text-info pt-3">$ {props.price}</h2>
        </div>

        <div className="card-button flex justify-between">
          <button
            type="button"
            className="btn btn-ghost"
            onClick={handleCheckout}
          >
            View Details
          </button>

          {(props.isAdmin ||
            (props.userId === props.currentUserId &&
              ["pending", "reviewed", "completed"].includes(props.status))) && (
            <div
              className="pr-4 pt-3 cursor-pointer"
              onClick={() => props.deleteOrder(props.orderId)}
            >
              <MdDeleteOutline className="text-2xl" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderCard;
